<div class="blur-content">
    <div class="page-container" style="background-color: #f2f8fa !important">
      <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
      <div class="main-content">
        <app-header></app-header>
        <div class="main-content-inner">
          <div class="row mt-5">
            <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important" >
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <div>
                    <h2>{{userName}}</h2>
                    <h6 >Record time spent working on specific clients (projects) and specific tasks.</h6>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="summary-card mr-3">
                        <p class="mb-0">Today: <strong>{{formatHours(todaysHours)}}</strong></p>
                      </div>
                      <div class="summary-card">
                        <p class="mb-0">Total: <strong>{{formatHours(totalHours)}}</strong></p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h5 class="mb-4">+ Add Time Entry</h5>
                    <form [formGroup]="newEntryForm" (ngSubmit)="addNewEntry()">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="project">Project</label>
                            <ng-select id="project" formControlName="project" class="form-control" [clearable]="true">
                              <ng-option value="Corporate">Corporate</ng-option>
                              <ng-option *ngFor="let project of projects" [value]="project">{{project}}</ng-option>
                              <ng-template ng-arrow-wrapper>
                                <div class="ng-arrow">
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="task">Task</label>
                            <ng-select id="task" formControlName="task" class="form-control" [clearable]="true">
                              <ng-option *ngFor="let task of tasks" [value]="task.taskName">{{task.taskName}}</ng-option>
                              <ng-template ng-arrow-wrapper>
                                <div class="ng-arrow">
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="date">Date</label>
                        <input type="date" id="date" formControlName="date" class="form-control">
                      </div>
                      <div class="form-group d-flex">
                        <div class="flex-grow-1 mr-2">
                          <label for="startTime">Start Time</label>
                          <div class="d-flex align-items-center mr-2">
                            <input type="time" id="startTime" formControlName="startTime" class="form-control">
                            <button type="button" (click)="setNow('startTime')" class="btn btn-link">Now</button>
                          </div> </div>
                        <div class="flex-grow-1">
                          <label for="endTime">End Time</label>
                          <div class="d-flex align-items-center">
                            <input type="time" id="endTime" formControlName="endTime" class="form-control">
                            <button type="button" (click)="setNow('endTime')" class="btn btn-link">Now</button>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="description">Description</label>
                        <textarea id="description" formControlName="description" class="form-control"></textarea>
                      </div>
                      <button type="submit" class="btn btn-primary btn-add-entry" [disabled]="isSubmitting">
                        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{isSubmitting ? 'Adding...' : 'Add Entry'}}
                      </button>
                    </form>
                    <div *ngIf="addEntryError" class="alert alert-danger mt-3">
                      {{addEntryError}}
                    </div>
                    <div *ngIf="successMessage" class="alert alert-success mt-3">{{successMessage}}</div>
                  </div>
                  <hr>
                  <div class="mt-5">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h3>Time Entries</h3>
                      <div class="d-flex align-items-center">
                        <input type="text" placeholder="yyyy-MM-dd" onfocus="this.type='date'" onblur="this.type='text'" id="startDate" [formControl]="startControl" class="form-control date-input mr-2">
                        <span class="mr-2">to</span>
                        <input type="text" placeholder="yyyy-MM-dd" onfocus="this.type='date'" onblur="this.type='text'" id="endDate" [formControl]="endControl" class="form-control date-input" [min]="startControl.value | date:'yyyy-MM-dd'" [disabled]="!startControl.value">
                        <div class="summary-card ml-3">
                          <p class="mb-0">Total: <strong>{{formatHours(totalHours)}}</strong></p>
                        </div>
                      </div>
                    </div>
                    <p class="mb-3">{{filteredDataSource.length}} entries</p>
                    <div *ngIf="inlineEditErrorMessage" class="alert alert-danger mt-3">{{inlineEditErrorMessage}}</div>

                    <div class="table-responsive">
                      <table class="table time-entry-table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Project</th>
                            <th>Task</th>
                            <th>Time</th>
                            <th>Hours</th>
                            <th>Description</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="isLoading">
                            <td colspan="7" class="text-center p-4">
                              <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </td>
                          </tr>
                          <ng-container *ngIf="!isLoading">
                            <tr *ngFor="let element of filteredDataSource">
                              <td>
                                <span *ngIf="!element.editable">{{element.entryDate | date: 'yyyy-MM-dd'}}</span>
                                <input *ngIf="element.editable" type="date" [(ngModel)]="element.entryDate" class="form-control">
                              </td>
                              <td>
                                <span *ngIf="!element.editable">{{element.project?element.project:'-'}}</span>
                                <ng-select *ngIf="element.editable" [(ngModel)]="element.project" title="Select Project" class="form-control" [clearable]="true">
                                  <ng-option value="Corporate">Corporate</ng-option>
                                  <ng-option *ngFor="let project of projects" [value]="project">{{project}}</ng-option>
                                </ng-select>
                              </td>
                              <td>
                                <span *ngIf="!element.editable">{{element.task?element.task:'-'}}</span>
                                <ng-select *ngIf="element.editable" [(ngModel)]="element.task" class="form-control" [clearable]="true">
                                  <ng-option *ngFor="let task of tasks" [value]="task.taskName">{{task.taskName}}</ng-option>
                                </ng-select>
                              </td>
                              <td>
                                <span *ngIf="!element.editable">{{element.startDateTime | date: 'shortTime'}} - {{element.endDateTime | date: 'shortTime'}}</span>
                                <ng-container *ngIf="element.editable">
                                  <input type="time" [(ngModel)]="element.startDateTime" class="form-control" title="Start Time">
                                  <input type="time" [(ngModel)]="element.endDateTime" class="form-control mt-1" title="End Time">
                                </ng-container>
                              </td>
                              <td>
                                <span>{{formatHours(element.hours)}}</span>
                              </td>
                              <td>
                                <span *ngIf="!element.editable">{{element.description?element.description:"-"}}</span>
                                <input *ngIf="element.editable" type="text" [(ngModel)]="element.description" class="form-control">
                              </td>
                              <td class="d-flex">
                                <ng-container *ngIf="!element.editable">
                                  <button (click)="editInlineEntry(element)" class="btn btn-sm btn-primary ml-1">
                                    <i class="fa fa-edit" style="font-size: 18px"></i>
                                  </button>
                                  <button (click)="deleteEntry(element)" class="btn btn-sm btn-info ml-1">
                                    <i class="fa fa-trash-o" style="font-size: 18px"></i>
                                  </button>
                                </ng-container>
                                <ng-container *ngIf="element.editable" class="d-flex">
                                  <button (click)="saveInlineEntry(element)" class="btn btn-sm btn-success mr-2">
                                    <i class="fa fa-save" style="font-size: 18px"></i>
                                  </button>
                                  <button (click)="cancelInlineEntry(element)" class="btn btn-sm btn-warning">
                                    <i class="fa fa-times" style="font-size: 18px"></i>
                                  </button>
                                </ng-container>
                              </td>
                            </tr>
                            <tr *ngIf="filteredDataSource.length === 0">
                              <td colspan="7" class="text-center p-4">No time entries found.</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                      <!-- Removed: Total hours from bottom of table -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
